// packages/shared-hooks/src/clients/useAddClientLegalEntity.ts
//
// `POST /clients/:id/legal-entities` — adds an OOO (10-digit INN) or IP
// (12-digit INN) entity to the client. INN uniqueness is enforced
// globally; duplicates surface as 409 DOMAIN_CONFLICT with
// `meta.field === 'inn'`.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  ClientLegalEntitySchema,
  type ClientLegalEntity,
  type ClientLegalEntityInput,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useAddClientLegalEntity(clientId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientLegalEntity, unknown, ClientLegalEntityInput>({
    mutationFn: (input) =>
      client.post<ClientLegalEntity>(
        `/clients/${clientId}/legal-entities`,
        input,
        {},
        ClientLegalEntitySchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
